<template>
  <div class="card">
    <a :href="link ? link : '#'">
      <div class="cover">
        <slot></slot>
      </div>
      <div class="text">
        <h3 v-html="title"></h3>
        <p>{{ subtitle }}</p>
      </div>
    </a>
  </div>
</template>
<style scoped lang="scss">
.card {
  border-radius: 20px;
  border: 1px solid #999;
  box-shadow: 0 0 3px #333;
  width: 350px;
  margin: 2em 1em;
  overflow: hidden;
  text-align: center;
  transition: 0.4s;
  &:hover {
    transform: translateY(-10px);
  }
  @media screen and (max-width: 450px) {
    margin: 1em 0.5em;
  }
  .cover::v-deep {
    height: 200px;
    background-size: cover;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .text {
    padding: 2em 1em;
  }
  h3 {
    margin: 0;
  }
  p {
    margin: 0;
  }
}
</style>
<script>
export default {
  props: ["title", "subtitle", "link"]
};
</script>
